import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import selfHeader from "./components/header"
import selfFooter from "./components/footer"
import selfFooterNew from "./components/footerNew"
import selfSlide from "./components/slide"
import selfAddress from "./components/address"
import BaiduMap from 'vue-baidu-map'
import VueWechatTitle from 'vue-wechat-title'
import { handleTree, useREM } from './util/util'
import geoJson from './util/china.json'
import MetaInfo from 'vue-meta-info'; // 引入 vue-meta-info 插件
// import VueCoreVideoPlayer from 'vue-core-video-player'
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// 引入 animated 动画
import animated from 'animate.css'
import '@/assets/css/common.css'
import * as echarts from "echarts";

useREM()
Vue.use(MetaInfo);
Vue.prototype.$global = global
Vue.prototype.handleTree = handleTree
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(VueCoreVideoPlayer)
// Vue.use(Viewer)
Vue.use(animated)
Vue.use(selfHeader)
Vue.use(selfFooter)
Vue.use(selfFooterNew)
Vue.use(selfSlide)
Vue.use(selfAddress)
Vue.use(VueWechatTitle)
echarts.registerMap('china', geoJson);
Vue.use(BaiduMap, {
  ak: 'OlY15NoxIYzjUbfHFsoWsUp7joD26D29'
})
// Viewer.setDefaults({
//   Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': false, 'zoomable': true, 'rotatable': false, 'scalable': false, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
// })
// Viewer.setDefaults({
//   // 需要配置的属性 注意属性并没有引号
//   title: false,
//   toolbar: true,
//   toggleOnDblclick: false
// })

/* eslint-disable no-new */
Vue.config.silent = true
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = "柠檬网联-" + to.meta.title
//   } else {
//     document.title = '柠檬网联'
//   }
//   next()
// })



// WEBPACK FOOTER //
// ./src/main.js